import { render, staticRenderFns } from "./ProductVariantSelector.vue?vue&type=template&id=06085492&scoped=true"
import script from "./ProductVariantSelector.vue?vue&type=script&lang=js"
export * from "./ProductVariantSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantSelector.vue?vue&type=style&index=0&id=06085492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06085492",
  null
  
)

export default component.exports